document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-add-qualtos-gift]');

  if (!button) return;

  const giftCard = button.closest('[data-gift-product]');
  const giftContainer = button.closest('[data-qualtos-free-gifts]');

  if (!giftCard || !giftContainer) return;

  const variantId = giftCard.dataset.variantId;
  const giftLimit = parseInt(giftContainer.dataset.giftLimit, 10);

  if (!variantId || !giftLimit) return;

  /*
   * Check how many Qualtos gifts are currently in the cart.
   */
  try {
    button.disabled = true;
    button.textContent = 'ADDING...';

    const cartResponse = await fetch(
      `${window.Shopify.routes.root}cart.js`,
      {
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    const cart = await cartResponse.json();

    const existingGifts = cart.items.filter(function (item) {
      return item.properties &&
        item.properties._qualtos_free_gift === 'true';
    });

    /*
     * Prevent the customer from exceeding
     * their allowed gift quantity.
     */
    if (existingGifts.length >= giftLimit) {
      button.disabled = false;
      button.textContent = 'LIMIT REACHED';
      return;
    }

    /*
     * Prevent the same gift from being selected twice.
     */
    const alreadySelected = existingGifts.some(function (item) {
      return String(item.variant_id) === String(variantId);
    });

    if (alreadySelected) {
      button.disabled = false;
      button.textContent = 'ADDED ✓';
      return;
    }

    /*
     * Add the selected eye mask to the cart.
     *
     * The line-item property identifies it as
     * a Qualtos free gift.
     */
    const addResponse = await fetch(
      `${window.Shopify.routes.root}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: {
                '_qualtos_free_gift': 'true'
              }
            }
          ]
        })
      }
    );

    if (!addResponse.ok) {
      throw new Error('Unable to add gift');
    }

    button.textContent = 'ADDED ✓';
    button.classList.add('is-added');

    /*
     * Refresh the cart drawer.
     */
    document.dispatchEvent(
      new CustomEvent('qualtos:gift-added')
    );

  } catch (error) {

    console.error('Qualtos free gift error:', error);

    button.disabled = false;
    button.textContent = 'ADD FREE GIFT';

  }
});